<template>
  <!-- App -->
  <f7-app :params="f7params">

    <f7-appbar class="bg-madai">
      <!-- <div class="left">
        <f7-button small panel-toggle="left" class="display-flex m-r-10 text-white" icon-f7="bars"></f7-button>
      -->
        <f7-link href="/">
          <img src="assets/img/logo.svg" alt="" height="25">
        </f7-link>
        <!--
      </div>
      <div class="right m-r-00">
        <f7-row class="w-100">
          <f7-col>
            <f7-link href="/wishlist/" class="heart custom-navbar no-ripple">
                <f7-icon class="heart" material="favorite" style="color: #a94442 !important; margin-top: 0 !important;">
                  <template v-if="storage.wishlist.length > 0">
                    <f7-badge class="fs-11 bold" color="red">{{ storage.wishlist.length }}</f7-badge>
                  </template>
                </f7-icon>
            </f7-link>
          </f7-col>
          <f7-col>
            <f7-link external target="_blank" href="https://wa.me/5218120140511?text=Me gustaría recibir información">
              <img src="assets/img/whatsapp.svg" alt="" width="22" height="22">
            </f7-link>
          </f7-col>
          <f7-col>
            <f7-link href="/carrito/" class="gray no-ripple">
                <f7-icon material="shopping_basket" color="white" class="text-white">
                  <template v-if="storage.carrito.length > 0">
                    <f7-badge class="fs-11 bold text-white" color="red">{{ storage.carrito.length }}</f7-badge>
                  </template>
                </f7-icon>
            </f7-link>
          </f7-col>
        </f7-row>
      </div>-->
    </f7-appbar>

    <!-- Statusbar -->
    <f7-statusbar></f7-statusbar>

    <!-- Left Panel -->
    <f7-panel class="w-320" left cover>
      <f7-view url="/menu-lateral/"></f7-view>
    </f7-panel>

    <!-- Right Panel -->
    <f7-panel right reveal>
      <f7-view url="/panel-right/"></f7-view>
    </f7-panel>

    <!-- Main View -->
    <f7-view id="main-view" url="/" main class="safe-areas" :pushState="true"></f7-view>

    <!-- Login Screen -->
    <f7-login-screen id="login-screen">
      <f7-view>
        <f7-page login-screen>
          <f7-login-screen-title>Login</f7-login-screen-title>
          <f7-list form>
            <f7-list-input
              label="Username"
              name="username"
              placeholder="Username"
              type="text"
            />
            <f7-list-input
              label="Password"
              name="password"
              type="password"
              placeholder="Password"
            />
          </f7-list>
          <f7-list>
            <f7-list-button title="Sign In" login-screen-close></f7-list-button>
            <f7-block-footer>
              <p>Click Sign In to close Login Screen</p>
            </f7-block-footer>
          </f7-list>
        </f7-page>
      </f7-view>
    </f7-login-screen>

  </f7-app>
</template>

<script>
/* eslint-disable */
import routes from './routes.js'
// let comp = {}

export default {
  data () {
    return {
      totalCarrito: 0,
      busqueda: [],
      f7params: {
        id: 'mx.madai.movil',
        name: 'Madai',
        theme: 'md',
        routes: routes,
        version: '1.9',
        view: {
          // routesBeforeEnter (to, from, resolve, reject) {
          //   if (to.url !== '/panel-right/' && to.url !== '/menu-lateral/' && to.hash !== '!/') {
          //     if (to.url === '/') {
          //       comp.$evento.emit('appbarstatus', false)
          //     } else {
          //       comp.$evento.emit('appbarstatus', true)
          //     }
          //   }
          //   resolve()
          // }
        },
        dialog: {
          buttonOk: 'OK',
          buttonCancel: 'No'
        }
      }
    }
  },
  watch: {
    'storage.wishlist': {
      handler (pos, prev) {
        let notificacion
        if (pos.length < prev.length) {
          notificacion = this.$f7.notification.create({
            title: 'MADAI',
            titleRightText: 'ahora',
            text: 'Eliminaste el artículo de tu <strong>wishlist</strong></span>',
            closeTimeout: 3000
          })
        } else {
          let detalles = pos[pos.length - 1]
          if (detalles) {
            notificacion = this.$f7.notification.create({
              icon: `<img src="//madai.mx/assets/images/${detalles.image}" width="60">`,
              title: '<span class="m-l-40">MADAI</span>',
              titleRightText: 'ahora',
              subtitle: '<span class="m-l-65">Hemos agregado el artículo a tu <strong>wishlist</strong></span>',
              text: '<span class="m-l-65">Haz clic aqui para ver tu wishlist</span>',
              closeTimeout: 3000,
              closeOnClick: true,
              on: {
                notificationClick: () => {
                  this.$f7.views.main.router.navigate('/wishlist/', { reloadCurrent: true })
                }
              }
            })
          }
        }
        if (notificacion) {
          notificacion.open()
        }
      }
    },
    'storage.carrito': {
      handler (pos, prev) {
        if (this.totalCarrito !== pos.length) {
          this.totalCarrito = pos.length
          let notificacion
          if (pos.length < prev.length) {
            notificacion = this.$f7.notification.create({
              title: 'MADAI',
              titleRightText: 'ahora',
              text: 'Eliminaste el artículo de tu <strong>carrito</strong></span>',
              closeTimeout: 3000
            })
          } else {
            let detalles = pos[pos.length - 1]
            notificacion = this.$f7.notification.create({
              icon: `<img src="//madai.mx/assets/images/${detalles.image}" width="60">`,
              title: '<span class="m-l-40">MADAI</span>',
              titleRightText: 'ahora',
              subtitle: '<span class="m-l-65">Hemos agregado el artículo a tu <strong>carrito</strong></span>',
              text: '<span class="m-l-65">Haz clic aqui para ver tu carrito</span>',
              closeTimeout: 3000,
              closeOnClick: true,
              on: {
                notificationClick: () => {
                  this.$f7.views.main.router.navigate('/carrito/', { reloadCurrent: true })
                }
              }
            })
          }
          if (this.storage.venta) {
            this.storage.venta = false
          } else {
            notificacion.open()
          }
        }
      }
    }
  },
  created () {
    setTimeout(async () => {
      if (this.storage.version !== this.$f7.version) {
        this.storage = Object.assign(this.storage, {
          version: this.$f7.version,
          aviso: false,
          carrito: [],
          wishlist: [],
          usuario: {},
          montura: '',
          diamante: '',
          token: '',
          cupon: {
            codigo: '',
            porcentaje: '',
            valido: false
          },
          guardarEnvio: false,
          guardarFacturacion: false,
          guardarDetalles: false,
          venta: false,
          transaccion: {
            id: '',
            intent: 'sale',
            state: '', // approved, declined
            cart: '',
            create_time: '',
            promos: [],
            payer: {
              payment_method: 'visa',
              status: '-',
              payer_info: {
                email: '',
                first_name: '',
                middle_name: '',
                last_name: '',
                payer_id: '-',
                country_code: 'MX',
                shipping_address: {
                  recipient_name: '',
                  line1: '',
                  city: '',
                  state: '',
                  postal_code: '',
                  country_code: 'MX',
                  suburb: ''
                },
                phone: '',
                name: ''
              }
            },
            transactions: [
              {
                amount: {
                  total: '',
                  currency: '',
                  details: {}
                },
                item_list: {
                  items: []
                },
                related_resources: []
              }
            ]
          }
        })
      }

      this.totalCarrito = this.storage.carrito.length

      if (this.storage.aviso === false) {
        var toastWithButton = this.$f7.toast.create({
          text: '<a href="/aviso/" class="text-white bold fs-14">Utilizamos cookies de terceros para generar estadísticas de audiencia. Lee aquí nuestro aviso de privacidad.</a>',
          closeButton: true,
          cssClass: 'text-white bold',
          closeButtonText: 'cerrar',
          closeButtonColor: 'white',
          on: {
            close: () => {
              this.storage.aviso = true
            }
          }
        })
        toastWithButton.open()
      }
    }, 0)

    setTimeout(() => {
      if (this.$f7.device.desktop) {
        //window.location.href = 'https://tienda.madai.mx'
      }
    }, 250)
  }
}
</script>

<style>
.m-l-31 {
  margin-left: 31px !important;
}
</style>
